import { Component, h, State, Element, Host } from '@stencil/core';
import { AppInstallAlertData } from './interfaces';

@Component({
  tag: 'salla-app-install-alert',
  styleUrl: 'salla-app-install-alert.scss',
})
export class SallaAppInstallAlert {

  alertDelay: NodeJS.Timeout = null

  connectedCallback() {
    salla.onReady(() => {
      this.data = salla.config.get('store.app_install_prompt')

      if (!this.isMobileOrTabletDevice()) return;

      if (!this.data) return salla.logger.error('Failed to retrieve salla-app-install-alert config')

      this.ctaLink = salla.url.get('app');
      this.alertDelay = setTimeout(() => (this.open = true), 3000);
    });
  }

  disconnectedCallback() {
    clearTimeout(this.alertDelay)
  }




  @State() data: AppInstallAlertData | null = salla.config.get('store.app_install_prompt');
  @State() ctaLink: string;
  @State() open: boolean = false;
  @State() closing: boolean = false;
  @Element() private host: HTMLElement;


  /**
   * Check if the website opens from mobile or tablet devices only (android/ios).
   *
   * @param {number} screen the width of the biggest screen to be checked
   * @returns {boolean} true if it is mobile or tablet else false
   */
  private isMobileOrTabletDevice(screen = 1024): boolean {
    const screenWidth = window.innerWidth <= screen;
    const userAgentCheck = /Macintosh|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const hasTouch =
      'ontouchstart' in window ||
      'ontouchend' in document ||
      navigator.maxTouchPoints > 0;

    return userAgentCheck && screenWidth && hasTouch;
  }

  closeAlert() {
    salla.storage.set('app_install_prompt_disabled', true);
    // handle closing animation first, then close the banner
    this.closing = true;
    this.host.addEventListener(
      'animationend',
      () => {
        this.closing = false
        this.open = false;
      },
      { once: true }
    );
  }


  render() {
    return this.data ? (
      <Host class={`s-app-install-alert-wrapper ${this.open ? 'open' : ''} ${this.closing ? 'closing' : ''}`} position={this.data.position}>
        <div>
          <img src={this.data.icon} width="58" height="58" alt={`${salla.config.get('store.name')}`} />
        </div>
        <div class="s-app-install-alert-content">
          <h2 class="s-app-install-alert-title">{this.data.title}</h2>
          <p class="s-app-install-alert-sub-title">
            {this.data.sub_title} {" "}
            <a href={this.ctaLink} target="_blank" aria-label="download app" class="s-app-install-alert-cta">
              {salla.lang.getWithDefault('blocks.footer.download_app_now', 'حمله الآن')}
            </a>
          </p>
        </div>
        <button class="s-app-install-alert-cancel-button" onClick={() => this.closeAlert()}>
          <i class="sicon-cancel"></i>
        </button>
      </Host>
    ) : null
  }
}
